
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { recommendedArtists } from '../../../mocks/musicData';
import Button from '../../../components/base/Button';

export default function RecommendedArtists() {
  const [followingArtists, setFollowingArtists] = useState<number[]>([2, 4]);
  const navigate = useNavigate();

  const toggleFollow = (artistId: number) => {
    setFollowingArtists(prev => 
      prev.includes(artistId) 
        ? prev.filter(id => id !== artistId)
        : [...prev, artistId]
    );
  };

  return (
    <section className="py-16 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="text-3xl font-bold text-gray-900 mb-2">Recommended Artists</h2>
            <p className="text-gray-600">Discover new artists based on your taste</p>
          </div>
          <button 
            onClick={() => navigate('/browse')}
            className="text-purple-600 hover:text-purple-700 font-medium cursor-pointer whitespace-nowrap"
          >
            Explore More
          </button>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {recommendedArtists.map((artist) => (
            <div 
              key={artist.id}
              className="bg-white rounded-2xl p-6 text-center shadow-sm hover:shadow-lg transition-all duration-300 cursor-pointer group"
            >
              <div className="relative mb-4">
                <img 
                  src={artist.imageUrl}
                  alt={artist.name}
                  className="w-24 h-24 rounded-full mx-auto object-cover object-top group-hover:scale-105 transition-transform duration-300"
                />
                <div className="absolute inset-0 bg-black/0 group-hover:bg-black/10 rounded-full transition-all duration-300"></div>
              </div>
              
              <h3 className="font-semibold text-gray-900 mb-1">{artist.name}</h3>
              <p className="text-sm text-gray-600 mb-2">{artist.genre}</p>
              <p className="text-xs text-gray-500 mb-4">{artist.followers} followers</p>
              
              <Button
                variant={followingArtists.includes(artist.id) ? 'secondary' : 'primary'}
                size="sm"
                onClick={() => toggleFollow(artist.id)}
                className="w-full"
              >
                {followingArtists.includes(artist.id) ? 'Following' : 'Follow'}
              </Button>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
